export default {
      id: "chevronLeft-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#chevronLeft-usage",
      toString: function () {
        return this.url;
      }
    }